import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { prettifyCardNumber, prettifyDate } from '../../../utils/string';
import { transactionShape } from '../../../utils/propTypes';
import './TransactionsListItem.scss';
import {
    cardTypesMapper,
    transactionStatusMapper,
    currencyMapper
} from '@nexio/emvio-util-app';
import { get } from 'lodash';
import ColorDollarAmountCell from '../../Table/Cells/ColorDollarAmountCell/ColorDollarAmountCell';
import { setOverrideMessageBasedOnStatus } from '../Transactions';

export default class TransactionsListItem extends Component {
    static propTypes = {
        item: transactionShape.isRequired,
        onGoToItem: PropTypes.func.isRequired
    };

    renderTransactionLabel(transaction) {
        let left, center = '-';

        if (transaction.cardNumber) {
            left = transaction.cardType ? cardTypesMapper[transaction.cardType].toUpperCase() : 'CARD';
            center = prettifyCardNumber(transaction.cardNumber);
        } else if (transaction.checkNumber) {
            left = 'CHECK';
            center = prettifyCardNumber(transaction.checkNumber);
        }

        return (
            <span className="transaction-label">
                <div>{left}</div>
                <div>{center}</div>
            </span>
        );
    }

    renderResult(transactionStatus) {
        return get(transactionStatusMapper, transactionStatus, '-').toUpperCase();
    }

    render() {
        const transaction = this.props.item;
        const currencyCode = get(currencyMapper, transaction.currencyId, '840').code;

        return (
            <div
                className="transaction-list-item"
                onClick={this.props.onGoToItem}
            >
                <div className="transaction-list-item-left">
                    {this.renderTransactionLabel(transaction)}
                    <span className="transaction-result">{this.renderResult(transaction.transactionStatus)}</span>
                </div>
                <div className="transaction-list-item-right">
                    <span className="transaction-amount">
                        <ColorDollarAmountCell amount={transaction.amount} currencyCode={currencyCode} overrideText={setOverrideMessageBasedOnStatus(transaction)} />
                    </span>
                    <span className="transaction-date">{prettifyDate(transaction.transactionDate, { returnDateOnly: true })}</span>
                </div>
            </div>
        );
    }
}
